import React from 'react';
import CookieConsent from "react-cookie-consent";
import Impressum from './impressum'
import Landing from './landing'
import Contact from './contact'
import Collections from './collections'
import Highlights from './highlights'
import Events from './events'
import News from './news'
import DataProtection from './dataprotection'
import $ from "jquery"

class Home extends React.Component {


    constructor(props) {
        super(props);
        var that = this;
        this.state = {
            selectedmenu: "home",
            mode: "mobile",
        }
        $(window).resize(function () {
            that.resize();
        });
    }
    componentDidMount() {
        this.resize();
    }

    resize() {
        var that = this;
        if ($(window).width() > $(window).height()) {
            if (this.state && this.state.mode === 'mobile') {
                that.setState({
                    mode: 'web'
                });
            }
        }
        else {
            if (this.state && this.state.mode === 'web') {
                that.setState({
                    mode: 'mobile'
                });
            }
        }
    }

    menukeytocaption(key) {
        var assignment = {
            "home": "",
            "schmuck": "Schmuckstücke",
            "highlights": "Highlights",
            "events": "Events",
            //"news": "News",
            "contac": "Kontakt"
        }
        return assignment[key];
    }



    changeContent = (index) => {
        if ($(".fixedmenu-sub").css("display") !== 'none') {
            $(".fixedmenu-sub").hide('slow');
        }
        this.setState({
            selectedmenu: index
        });
    };

    toggleMenu() {
        if ($(".fixedmenu-sub").css("display") === 'none') {
            $(".fixedmenu-sub").show('slow');
        }
        else {
            $(".fixedmenu-sub").hide('slow');
        }
    }

    render() {

        var header = this.createHeader();
        var menu = this.createMenu();
        var content = (<div></div>);
        var prefooter = this.createPrefooter();
        var footer = this.createFooter();
        var cookies = this.createCookieConsent();
        if (this.state.selectedmenu === 'home') {
            content = <Landing />
        }
        if (this.state.selectedmenu === 'impressum') {
            content = <Impressum />
        }
        if (this.state.selectedmenu === 'dataprotection') {
            content = <DataProtection />
        }
        if (this.state.selectedmenu === 'schmuck') {
            content = <Collections />
        }
        if (this.state.selectedmenu === 'highlights') {
            content = <Highlights />
        }
        // if (this.state.selectedmenu === 'events') {
        //     content = <Events />
        // }
        // if (this.state.selectedmenu === 'news') {
        //     content = <News />
        // }
        if (this.state.selectedmenu === 'contact') {
            content = <Contact />
        }

        return (
            <div class='fullwidth fullheight floatrelative'>
                {header}
                {menu}
                <div class='mainarea'>
                    {content}
                </div>
                {prefooter}
                {footer}
                {cookies}
            </div >
        );
    }

    createHeader() {
        return (<div class='fixedheader'>
            <div class='fullwidthcontainer'>
                <img src="./assets/logo_wide.png" alt="Augenstern" class='centeredlogo' onClick={() => this.changeContent('home')} />
            </div>
        </div>)
    }

    createMenu() {
        if (this.state.mode == 'web') {

            return (<div class='fixedmenu'>
                <div class='fullwidthcontainer'>
                    <div class='centercontainer'>
                        <div class={this.state.selectedmenu == 'schmuck' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('schmuck')}>Schmuckst&uuml;cke</div>
                        <div class={this.state.selectedmenu == 'highlights' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('highlights')}>Highlights</div>
                        {/* <div class={this.state.selectedmenu == 'events' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('events')}>Events</div> */}
                        {/* <div class={this.state.selectedmenu == 'news' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('news')}>News</div> */}
                        <div class={this.state.selectedmenu == 'contact' ? 'menuitem-selected' : 'menuitem'} onClick={() => this.changeContent('contact')}>Kontakt</div>
                    </div>
                </div>
            </div>)
        }
        else {
            return (
                <div>
                    <div class='fixedmenu'>
                        <div class='floatrelative menuitem center'>
                            {this.menukeytocaption(this.state.selectedmenu)}
                        </div>
                        <img src="./assets/menu-burger.png" alt="Menu" class='menuicon' onClick={() => this.toggleMenu()} />
                    </div>
                    <div class='fixedmenu-sub' id='togglemenu'>
                        <div class='fullwidthcontainer'>
                            <div class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('schmuck')}>Schmuckst&uuml;cke</div>
                            <div class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('highlights')}>Highlights</div>
                            <div class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('events')}>Events</div>
                            <div class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('news')}>News</div>
                            <div class='fullwidthcontainer menuitem center' onClick={() => this.changeContent('contact')}>Kontakt</div>
                        </div>
                    </div>
                </div>
            )
        }
    }

    createPrefooter() {
        return (<div class='prefooter'>
            <div class='fullwidthcontainer'>
                <img src="./assets/logo_wide.png" alt="Augenstern" class='centeredlogo' />
            </div>
            <div class='fullwidthcontainer'>
                <div class='halfwidthcontainer'>
                    <div class='header1'>Augenstern Schmuck e.K.</div>
                    <div class='text'>
                        Alexandra Gabriele Faltermeier <br />
                        Telefon: (+49) 151 11198897
                    </div>
                </div>
                <div class='halfwidthcontainer'>
                    <div class='header1'>Showroom</div>
                    <div class='text'>
                        Stadtgraben 34<br />
                        94368 Straubing<br />
                    </div>
                    <div class='header2'>Öffnungszeiten</div>
                    <div class='text'>
                        Donnerstag &amp; Freitag 10:00 - 17:00 Uhr<br />
                        und nach Vereinbarung
                    </div>
                </div>
            </div>
        </div>);
    }

    createFooter() {
        return (<div class='footer'>
            <div class='footermenu'>
                <div class='footermenuitem' onClick={() => this.changeContent('impressum')}>Impressum</div>
                <div class='footermenuitem' onClick={() => this.changeContent('dataprotection')}>Datenschutz</div>
            </div>
            <div class='footercopyright'>
                2023 © Augenstern Schmuck e.K.
            </div>
        </div>);
    }

    createCookieConsent() {
        return (<CookieConsent
            location="bottom"
            buttonText="Akzeptieren"
            cookieName="AugensternCookieConsent"
            style={{ background: "#000000", fontSize: "20px", fontFamily: "Garamond" }}
            buttonStyle={{ background: "#737373", color: "#FFFFFF", fontSize: "20px" }}
            expires={0}
            debug={false}
            overlay={true}
        >
            Wir verwenden Cookies um die Benutzerfreundlichkeit zu verbessern. Bitte akzeptieren Sie um die Seite besuchen zu können!{" "}
        </CookieConsent>);
    }
}


export default (Home);